import { render, staticRenderFns } from "./CoursesAndInstructorsMain.vue?vue&type=template&id=c3c5e5c0&scoped=true"
import script from "./CoursesAndInstructorsMain.vue?vue&type=script&lang=js"
export * from "./CoursesAndInstructorsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c5e5c0",
  null
  
)

export default component.exports